import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';
import '../styles/Hero.css';

const Hero: React.FC = () => {
  const navigate = useNavigate();

  const handleScroll = () => {
    window.scrollBy({ top: window.innerHeight, behavior: 'smooth' });
  };

  return (
    <section className="hero-section">
      <img
        src="/img/bg-hero-home.jpg"
        alt="Agricultura na Campanha Gaúcha"
        className="hero-background"
        loading="eager"
      />
      <div className="hero-overlay" />

      <Container>
        <div className="hero-content">
          <p className="hero-tagline">Sempre ao lado do produtor</p>
          <h1 className="hero-title">
            Unidos pela força do<br />campo e da Campanha
          </h1>
          <p className="hero-subtitle">
            Representamos os produtores rurais da Região da Campanha,
            promovendo informação de qualidade, integração e
            responsabilidade social.
          </p>
          <div className="hero-cta-group">
            <Button
              variant="accent"
              size="lg"
              aria-label="Quero ser associado da Agricampanha"
              onClick={() => navigate('/#contato')}
            >
              Quero ser associado
            </Button>
            <Button
              variant="outline-light"
              size="lg"
              aria-label="Ver projetos da Agricampanha"
              onClick={() => navigate('/#projetos')}
            >
              Ver projetos
            </Button>
          </div>
        </div>
      </Container>

      {/* Scroll indicator */}
      <button className="hero-scroll-indicator" onClick={handleScroll} aria-label="Rolar para baixo">
        <span className="hero-scroll-label">Role para baixo</span>
        <div className="hero-scroll-arrow">
          <i className="bi bi-chevron-down"></i>
        </div>
      </button>
    </section>
  );
};

export default Hero;
